module.exports = __webpack_public_path__ + "8cf1bd655a7c0b9eae707e3db3437c47.png";